import { Button, Spinner } from '@/components/ui'
import { useDaylistPreparation } from './daylistPlayback'

export function DaylistPreparation() {
  const { daylistId, name, ready, total, cancel } = useDaylistPreparation()
  if (daylistId === null) return null
  return (
    <div role="status" className="mx-auto flex max-w-5xl items-center gap-3 px-4 py-3">
      <Spinner size="sm" label="Preparing songs" />
      <p className="min-w-0 flex-1 text-sm text-text-muted">Preparing {name} · {ready}/{total} ready</p>
      <Button size="sm" variant="ghost" onClick={cancel}>Cancel</Button>
    </div>
  )
}
